import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import './Tooltip.scss';

class Tooltip extends React.Component {
  constructor() {
    super();

    this.state = { shouldShow: false };
    this.close = this.close.bind(this);
    this.open = this.open.bind(this);
  }

  close() {
    this.setState({ shouldShow: false });
  }

  open = (e) => {
    e.preventDefault();
    this.setState({ shouldShow: true });
  };

  render() {
    return (
      <a className="tooltip-link" href="/" onClick={this.open}>
        {!this.props.title &&
        <div className="tooltip-icon">
          <span className="help-icon" aria-hidden="true">?</span>
          <span className="sr-only">Click for more info</span>
        </div>
        }
        {this.props.title &&
        <span>{this.props.title}</span>
        }
        {this.props.hasIcon &&
        <span className="tooltip-icon">
          <span className="help-icon" aria-hidden="true">?</span>
          <span className="sr-only">Click for more info</span>
        </span>
        }
        <Modal dialogClassName="skinny-modal" show={this.state.shouldShow} onHide={this.close}>
          <Modal.Header className="automation-selling-point-modal-header" closeButton>
            <h4>{this.props.modalHeading}</h4>
          </Modal.Header>
          <Modal.Body>
            <div className="skinny-modal-text automation-selling-point-text">
              {this.props.modalDescription}
              {this.props.children}
            </div>
          </Modal.Body>
        </Modal>
      </a>
    );
  }
}

Tooltip.propTypes = {
  title: PropTypes.string,
  modalHeading: PropTypes.string,
  modalDescription: PropTypes.string,
  hasIcon: PropTypes.bool,
  children: PropTypes.node
};

export default Tooltip;



/** WEBPACK FOOTER **
 ** ./src/components/Tooltip/Tooltip.js
 **/